import React, { useContext, useEffect, useState } from 'react';
import { Context } from '@routes/private/Editor/Context';
import { IProps } from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import CropIcon from '@assets/icons/cropIcon';
import ToolTip from '@components/Tooltip';

const CropCommandOption : React.FC<IProps> = () => {
  const { stageRef, editorStatus, onShowCropImage, onCancelCropImage } = useContext(Context);
  
  const showCrop = () => {  
      onShowCropImage(!editorStatus.showCropImage);
    
  }
  //DOS-79 Find and Move crop group to layer top position (momentary while the crop tool is active)
  const findCropElement =() => {
    if (editorStatus.selectedElementsId.length !== 1) return;
    editorStatus.selectedElementsId.forEach((elementId: string) => {
    const layer = stageRef.current?.getLayers()[0];
    const cropElement = layer?.findOne(`.crop-${elementId}`);
    if (!cropElement || !layer) return;
    layer.add(cropElement as any)
    })
  }
  //DOS-79 Run findCropElement after the canvas has been rendered
  React.useEffect(() => {
    if (editorStatus.showCropImage) {
      findCropElement()
    }
  }, [editorStatus.showCropImage])
  
  return (
    <S.Root>
      <ToolTip
        tip="Crop"
      >
        <S.IconContainer
          onClick={showCrop}
          backgroundColorValue={editorStatus.showCropImage ? C.DARK_BLUE : 'auto'}
          cropping={editorStatus.showCropImage}
        >
          <CropIcon/>
        </S.IconContainer>
      </ToolTip>
      {editorStatus.showCropImage &&
      <>
        <S.Line/>
        <S.ButtonContainer onClick={()=> { if (Object.keys(editorStatus.beforeCroppedImage).length !== 0)  onShowCropImage(false, true)}} active={ Object.keys(editorStatus.beforeCroppedImage).length !== 0}>
          Save
        </S.ButtonContainer>
        <S.Line/>
        <S.ButtonContainer onClick={()=>onShowCropImage(false, false)} onMouseDown={()=>onCancelCropImage()} active={true}>
          Cancel
        </S.ButtonContainer>
      </>}
    </S.Root>
  );
}

export default CropCommandOption;